var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowUpwardLight = function SvgIconArrowUpwardLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_arrow_upward_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 37.1V11.2h2.2v25.9h-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.178 10.768c.89-1.056 2.436-.91 3.3-.046l.018.02 10.1 10.6-1.592 1.517-10.087-10.587a.172.172 0 0 0-.09-.046 1.066 1.066 0 0 1-.034.037l-10.2 10.6-1.586-1.526 10.171-10.57Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_arrow_upward_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 10)",
    d: "M0 0h23.6v27.1H0z"
  })))));
};
export default SvgIconArrowUpwardLight;